import React, { useEffect, forwardRef, useState } from 'react';
import { Table } from "antd";
import "./TableSelector.css";

const TableSelector = (props) => {
    const { value, onChange, columns, dataSource, pagination, loading, rowStyle, onTableChange, disabled } = props;

    const handleselection = (record, selected, selectedRows, nativeEvent) => {
        if (onChange && selected && record && !disabled) {
            onChange(record.id);
        }
    };

    useEffect(() => {
        console.log('SELECTED=' + value);
    }, [value]);

    return (
        <Table
            rowClassName={(record, index) => {
                let className = index % 2 === 0 ? 'table-row-light' : 'table-row-dark';
                if (disabled) className += ' disabled-table-row';
                return className;
            }}
            rowSelection={{
                selectedRowKeys: [].concat(value || []), 
                type: 'radio', 
                onSelect: handleselection, 
                getCheckboxProps: (record) => {
                    return {
                        disabled: disabled || record.dummy
                    }
                }
            }}
            size="small"
            style={{ opacity: disabled ? 0.7 : 1 }}
            scroll={{ y: 250 }}
            columns={columns}
            rowKey={record => record.id}
            dataSource={dataSource}
            pagination={pagination}
            loading={loading}
            onChange={onTableChange}
        />
    )
};

export default TableSelector;